import { defineComponent as _defineComponent } from 'vue'
import { TUIRole } from '@tencentcloud/tuiroom-engine-js';
import useEndControl from './useEndControlHooks';
import logger from '../../../utils/common/logger';
import popup from '../../common/base/PopUpH5.vue';
import SvgIcon from '../../common/base/SvgIcon.vue';
import CorrectIcon from '../../common/icons/CorrectIcon.vue';
import SearchIcon from '../../common/icons/SearchIcon.vue';
import Avatar from '../../common/Avatar.vue';
import '../../../directives/vTap';
import EndRoomIcon from '../../common/icons/EndRoomIcon.vue';
import { roomService } from '../../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'EndControlH5',
  setup(__props) {

const {
  t,
  isShowLeaveRoomDialog,
  roomStore,
  roomEngine,
  stopMeeting,
  cancel,
  DialogType,
  logPrefix,
  currentDialogType,
  visible,
  resetState,
  toggleMangeMemberSidebar,
  searchName,
  hasNoData,
  handleShowMemberControl,
  filteredList,
  selectedUser,
  showSideBar,
  remoteEnteredUserList,
  isMasterWithOneRemoteUser,
  isMasterWithRemoteUser,
} = useEndControl();

function handleEndBtnClick() {
  stopMeeting();
}
function handleEndLeaveClick() {
  if (!roomStore.isMaster) {
    leaveRoom();
    return;
  }
  if (isMasterWithRemoteUser.value) {
    selectedUser.value = remoteEnteredUserList.value[0].userId;
    if (isMasterWithOneRemoteUser.value) {
      transferAndLeave();
      return;
    }
    currentDialogType.value = DialogType.TransferDialog;
    toggleMangeMemberSidebar();
    resetState();
    return;
  }
}

/**
 * Active room dismissal
 **/
async function dismissRoom() {
  try {
    logger.log(`${logPrefix}dismissRoom: enter`);
    resetState();
    await roomService.dismissRoom();
  } catch (error) {
    logger.error(`${logPrefix}dismissRoom error:`, error);
  }
}

/**
 * Leave the room voluntarily
 **/
async function leaveRoom() {
  // eslint-disable-line
  try {
    resetState();
    await roomService.leaveRoom();
  } catch (error) {
    logger.error(`${logPrefix}leaveRoom error:`, error);
  }
}

async function transferAndLeave() {
  if (!selectedUser.value) {
    return;
  }
  try {
    const userId = selectedUser.value;
    const changeUserRoleResponse = await roomEngine.instance?.changeUserRole({
      userId,
      userRole: TUIRole.kRoomOwner,
    });
    logger.log(`${logPrefix}transferAndLeave:`, changeUserRoleResponse);
    resetState();
    await roomService.leaveRoom();
  } catch (error) {
    logger.error(`${logPrefix}transferAndLeave error:`, error);
  }
}

return { __sfc: true,t, isShowLeaveRoomDialog, roomStore, roomEngine, stopMeeting, cancel, DialogType, logPrefix, currentDialogType, visible, resetState, toggleMangeMemberSidebar, searchName, hasNoData, handleShowMemberControl, filteredList, selectedUser, showSideBar, remoteEnteredUserList, isMasterWithOneRemoteUser, isMasterWithRemoteUser, handleEndBtnClick, handleEndLeaveClick, dismissRoom, leaveRoom, transferAndLeave, popup, SvgIcon, CorrectIcon, SearchIcon, Avatar, EndRoomIcon, roomService }
}

})